module.exports = "fragment MarketingParagraphFragment on MarketingParagraph {\n  __typename\n  title\n  content\n}\n"